import script from "./NavComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./NavComponent.vue?vue&type=script&setup=true&lang=js"

import "./NavComponent.vue?vue&type=style&index=0&id=1080297a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1080297a"]])

export default __exports__